export const isWebAuthnAccount = (owner) => {
    return owner.type === "webAuthn";
};
//# sourceMappingURL=isWebAuthnAccount.js.map